"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObjectStatisticsApi = exports.ObjectMessageAttemptApi = exports.ObjectMessageApi = exports.ObjectIntegrationApi = exports.ObjectHealthApi = exports.ObjectEventTypeApi = exports.ObjectEnvironmentSettingsApi = exports.ObjectEnvironmentApi = exports.ObjectEndpointApi = exports.ObjectAuthenticationApi = exports.ObjectApplicationApi = void 0;
const ObservableAPI_1 = require("./ObservableAPI");
class ObjectApplicationApi {
    constructor(configuration, requestFactory, responseProcessor) {
        this.api = new ObservableAPI_1.ObservableApplicationApi(configuration, requestFactory, responseProcessor);
    }
    createApplicationApiV1AppPost(param, options) {
        return this.api.createApplicationApiV1AppPost(param.applicationIn, param.getIfExists, param.idempotencyKey, options).toPromise();
    }
    deleteApplicationApiV1AppAppIdDelete(param, options) {
        return this.api.deleteApplicationApiV1AppAppIdDelete(param.appId, param.idempotencyKey, options).toPromise();
    }
    getApplicationApiV1AppAppIdGet(param, options) {
        return this.api.getApplicationApiV1AppAppIdGet(param.appId, param.idempotencyKey, options).toPromise();
    }
    listApplicationsApiV1AppGet(param, options) {
        return this.api.listApplicationsApiV1AppGet(param.iterator, param.limit, param.idempotencyKey, options).toPromise();
    }
    updateApplicationApiV1AppAppIdPut(param, options) {
        return this.api.updateApplicationApiV1AppAppIdPut(param.appId, param.applicationIn, param.idempotencyKey, options).toPromise();
    }
}
exports.ObjectApplicationApi = ObjectApplicationApi;
const ObservableAPI_2 = require("./ObservableAPI");
class ObjectAuthenticationApi {
    constructor(configuration, requestFactory, responseProcessor) {
        this.api = new ObservableAPI_2.ObservableAuthenticationApi(configuration, requestFactory, responseProcessor);
    }
    getDashboardAccessApiV1AuthDashboardAccessAppIdPost(param, options) {
        return this.api.getDashboardAccessApiV1AuthDashboardAccessAppIdPost(param.appId, param.idempotencyKey, options).toPromise();
    }
    logoutApiV1AuthLogoutPost(param, options) {
        return this.api.logoutApiV1AuthLogoutPost(param.idempotencyKey, options).toPromise();
    }
}
exports.ObjectAuthenticationApi = ObjectAuthenticationApi;
const ObservableAPI_3 = require("./ObservableAPI");
class ObjectEndpointApi {
    constructor(configuration, requestFactory, responseProcessor) {
        this.api = new ObservableAPI_3.ObservableEndpointApi(configuration, requestFactory, responseProcessor);
    }
    createEndpointApiV1AppAppIdEndpointPost(param, options) {
        return this.api.createEndpointApiV1AppAppIdEndpointPost(param.appId, param.endpointIn, param.idempotencyKey, options).toPromise();
    }
    deleteEndpointApiV1AppAppIdEndpointEndpointIdDelete(param, options) {
        return this.api.deleteEndpointApiV1AppAppIdEndpointEndpointIdDelete(param.endpointId, param.appId, param.idempotencyKey, options).toPromise();
    }
    getEndpointApiV1AppAppIdEndpointEndpointIdGet(param, options) {
        return this.api.getEndpointApiV1AppAppIdEndpointEndpointIdGet(param.endpointId, param.appId, param.idempotencyKey, options).toPromise();
    }
    getEndpointHeadersApiV1AppAppIdEndpointEndpointIdHeadersGet(param, options) {
        return this.api.getEndpointHeadersApiV1AppAppIdEndpointEndpointIdHeadersGet(param.endpointId, param.appId, param.idempotencyKey, options).toPromise();
    }
    getEndpointSecretApiV1AppAppIdEndpointEndpointIdSecretGet(param, options) {
        return this.api.getEndpointSecretApiV1AppAppIdEndpointEndpointIdSecretGet(param.endpointId, param.appId, param.idempotencyKey, options).toPromise();
    }
    getEndpointStatsApiV1AppAppIdEndpointEndpointIdStatsGet(param, options) {
        return this.api.getEndpointStatsApiV1AppAppIdEndpointEndpointIdStatsGet(param.endpointId, param.appId, param.idempotencyKey, options).toPromise();
    }
    listEndpointsApiV1AppAppIdEndpointGet(param, options) {
        return this.api.listEndpointsApiV1AppAppIdEndpointGet(param.appId, param.iterator, param.limit, param.idempotencyKey, options).toPromise();
    }
    patchEndpointHeadersApiV1AppAppIdEndpointEndpointIdHeadersPatch(param, options) {
        return this.api.patchEndpointHeadersApiV1AppAppIdEndpointEndpointIdHeadersPatch(param.appId, param.endpointId, param.endpointHeadersIn, param.idempotencyKey, options).toPromise();
    }
    recoverFailedWebhooksApiV1AppAppIdEndpointEndpointIdRecoverPost(param, options) {
        return this.api.recoverFailedWebhooksApiV1AppAppIdEndpointEndpointIdRecoverPost(param.appId, param.endpointId, param.recoverIn, param.idempotencyKey, options).toPromise();
    }
    rotateEndpointSecretApiV1AppAppIdEndpointEndpointIdSecretRotatePost(param, options) {
        return this.api.rotateEndpointSecretApiV1AppAppIdEndpointEndpointIdSecretRotatePost(param.endpointId, param.appId, param.endpointSecretRotateIn, param.idempotencyKey, options).toPromise();
    }
    sendEventTypeExampleMessageApiV1AppAppIdEndpointEndpointIdSendExamplePost(param, options) {
        return this.api.sendEventTypeExampleMessageApiV1AppAppIdEndpointEndpointIdSendExamplePost(param.appId, param.endpointId, param.eventExampleIn, param.idempotencyKey, options).toPromise();
    }
    updateEndpointApiV1AppAppIdEndpointEndpointIdPut(param, options) {
        return this.api.updateEndpointApiV1AppAppIdEndpointEndpointIdPut(param.endpointId, param.appId, param.endpointUpdate, param.idempotencyKey, options).toPromise();
    }
    updateEndpointHeadersApiV1AppAppIdEndpointEndpointIdHeadersPut(param, options) {
        return this.api.updateEndpointHeadersApiV1AppAppIdEndpointEndpointIdHeadersPut(param.appId, param.endpointId, param.endpointHeadersIn, param.idempotencyKey, options).toPromise();
    }
}
exports.ObjectEndpointApi = ObjectEndpointApi;
const ObservableAPI_4 = require("./ObservableAPI");
class ObjectEnvironmentApi {
    constructor(configuration, requestFactory, responseProcessor) {
        this.api = new ObservableAPI_4.ObservableEnvironmentApi(configuration, requestFactory, responseProcessor);
    }
    exportEnvironmentConfigurationApiV1EnvironmentExportPost(param, options) {
        return this.api.exportEnvironmentConfigurationApiV1EnvironmentExportPost(param.body, param.idempotencyKey, options).toPromise();
    }
    importEnvironmentConfigurationApiV1EnvironmentImportPost(param, options) {
        return this.api.importEnvironmentConfigurationApiV1EnvironmentImportPost(param.environmentIn, param.idempotencyKey, options).toPromise();
    }
}
exports.ObjectEnvironmentApi = ObjectEnvironmentApi;
const ObservableAPI_5 = require("./ObservableAPI");
class ObjectEnvironmentSettingsApi {
    constructor(configuration, requestFactory, responseProcessor) {
        this.api = new ObservableAPI_5.ObservableEnvironmentSettingsApi(configuration, requestFactory, responseProcessor);
    }
    getOrgSettingsApiV1EnvironmentSettingsGet(param, options) {
        return this.api.getOrgSettingsApiV1EnvironmentSettingsGet(param.idempotencyKey, options).toPromise();
    }
}
exports.ObjectEnvironmentSettingsApi = ObjectEnvironmentSettingsApi;
const ObservableAPI_6 = require("./ObservableAPI");
class ObjectEventTypeApi {
    constructor(configuration, requestFactory, responseProcessor) {
        this.api = new ObservableAPI_6.ObservableEventTypeApi(configuration, requestFactory, responseProcessor);
    }
    createEventTypeApiV1EventTypePost(param, options) {
        return this.api.createEventTypeApiV1EventTypePost(param.eventTypeIn, param.idempotencyKey, options).toPromise();
    }
    deleteEventTypeApiV1EventTypeEventTypeNameDelete(param, options) {
        return this.api.deleteEventTypeApiV1EventTypeEventTypeNameDelete(param.eventTypeName, param.idempotencyKey, options).toPromise();
    }
    generateSchemaExampleApiV1EventTypeSchemaGenerateExamplePost(param, options) {
        return this.api.generateSchemaExampleApiV1EventTypeSchemaGenerateExamplePost(param.eventTypeSchemaIn, param.idempotencyKey, options).toPromise();
    }
    getEventTypeApiV1EventTypeEventTypeNameGet(param, options) {
        return this.api.getEventTypeApiV1EventTypeEventTypeNameGet(param.eventTypeName, param.idempotencyKey, options).toPromise();
    }
    listEventTypesApiV1EventTypeGet(param, options) {
        return this.api.listEventTypesApiV1EventTypeGet(param.iterator, param.limit, param.withContent, param.includeArchived, param.idempotencyKey, options).toPromise();
    }
    updateEventTypeApiV1EventTypeEventTypeNamePut(param, options) {
        return this.api.updateEventTypeApiV1EventTypeEventTypeNamePut(param.eventTypeName, param.eventTypeUpdate, param.idempotencyKey, options).toPromise();
    }
}
exports.ObjectEventTypeApi = ObjectEventTypeApi;
const ObservableAPI_7 = require("./ObservableAPI");
class ObjectHealthApi {
    constructor(configuration, requestFactory, responseProcessor) {
        this.api = new ObservableAPI_7.ObservableHealthApi(configuration, requestFactory, responseProcessor);
    }
    healthApiV1HealthGet(param, options) {
        return this.api.healthApiV1HealthGet(param.idempotencyKey, options).toPromise();
    }
}
exports.ObjectHealthApi = ObjectHealthApi;
const ObservableAPI_8 = require("./ObservableAPI");
class ObjectIntegrationApi {
    constructor(configuration, requestFactory, responseProcessor) {
        this.api = new ObservableAPI_8.ObservableIntegrationApi(configuration, requestFactory, responseProcessor);
    }
    createIntegrationApiV1AppAppIdIntegrationPost(param, options) {
        return this.api.createIntegrationApiV1AppAppIdIntegrationPost(param.appId, param.integrationIn, param.idempotencyKey, options).toPromise();
    }
    deleteIntegrationApiV1AppAppIdIntegrationIntegIdDelete(param, options) {
        return this.api.deleteIntegrationApiV1AppAppIdIntegrationIntegIdDelete(param.integId, param.appId, param.idempotencyKey, options).toPromise();
    }
    getIntegrationApiV1AppAppIdIntegrationIntegIdGet(param, options) {
        return this.api.getIntegrationApiV1AppAppIdIntegrationIntegIdGet(param.integId, param.appId, param.idempotencyKey, options).toPromise();
    }
    getIntegrationKeyApiV1AppAppIdIntegrationIntegIdKeyGet(param, options) {
        return this.api.getIntegrationKeyApiV1AppAppIdIntegrationIntegIdKeyGet(param.integId, param.appId, param.idempotencyKey, options).toPromise();
    }
    listIntegrationsApiV1AppAppIdIntegrationGet(param, options) {
        return this.api.listIntegrationsApiV1AppAppIdIntegrationGet(param.appId, param.iterator, param.limit, param.idempotencyKey, options).toPromise();
    }
    rotateIntegrationKeyApiV1AppAppIdIntegrationIntegIdKeyRotatePost(param, options) {
        return this.api.rotateIntegrationKeyApiV1AppAppIdIntegrationIntegIdKeyRotatePost(param.integId, param.appId, param.idempotencyKey, options).toPromise();
    }
    updateIntegrationApiV1AppAppIdIntegrationIntegIdPut(param, options) {
        return this.api.updateIntegrationApiV1AppAppIdIntegrationIntegIdPut(param.integId, param.appId, param.integrationUpdate, param.idempotencyKey, options).toPromise();
    }
}
exports.ObjectIntegrationApi = ObjectIntegrationApi;
const ObservableAPI_9 = require("./ObservableAPI");
class ObjectMessageApi {
    constructor(configuration, requestFactory, responseProcessor) {
        this.api = new ObservableAPI_9.ObservableMessageApi(configuration, requestFactory, responseProcessor);
    }
    createMessageApiV1AppAppIdMsgPost(param, options) {
        return this.api.createMessageApiV1AppAppIdMsgPost(param.appId, param.messageIn, param.withContent, param.idempotencyKey, options).toPromise();
    }
    getMessageApiV1AppAppIdMsgMsgIdGet(param, options) {
        return this.api.getMessageApiV1AppAppIdMsgMsgIdGet(param.msgId, param.appId, param.idempotencyKey, options).toPromise();
    }
    listMessagesApiV1AppAppIdMsgGet(param, options) {
        return this.api.listMessagesApiV1AppAppIdMsgGet(param.appId, param.iterator, param.limit, param.eventTypes, param.channel, param.before, param.after, param.idempotencyKey, options).toPromise();
    }
}
exports.ObjectMessageApi = ObjectMessageApi;
const ObservableAPI_10 = require("./ObservableAPI");
class ObjectMessageAttemptApi {
    constructor(configuration, requestFactory, responseProcessor) {
        this.api = new ObservableAPI_10.ObservableMessageAttemptApi(configuration, requestFactory, responseProcessor);
    }
    getAttemptApiV1AppAppIdMsgMsgIdAttemptAttemptIdGet(param, options) {
        return this.api.getAttemptApiV1AppAppIdMsgMsgIdAttemptAttemptIdGet(param.attemptId, param.msgId, param.appId, param.idempotencyKey, options).toPromise();
    }
    listAttemptedDestinationsApiV1AppAppIdMsgMsgIdEndpointGet(param, options) {
        return this.api.listAttemptedDestinationsApiV1AppAppIdMsgMsgIdEndpointGet(param.msgId, param.appId, param.iterator, param.limit, param.idempotencyKey, options).toPromise();
    }
    listAttemptedMessagesApiV1AppAppIdEndpointEndpointIdMsgGet(param, options) {
        return this.api.listAttemptedMessagesApiV1AppAppIdEndpointEndpointIdMsgGet(param.endpointId, param.appId, param.iterator, param.limit, param.channel, param.status, param.before, param.after, param.idempotencyKey, options).toPromise();
    }
    listAttemptsApiV1AppAppIdMsgMsgIdAttemptGet(param, options) {
        return this.api.listAttemptsApiV1AppAppIdMsgMsgIdAttemptGet(param.appId, param.msgId, param.iterator, param.limit, param.endpointId, param.eventTypes, param.channel, param.status, param.before, param.after, param.idempotencyKey, options).toPromise();
    }
    listAttemptsByEndpointApiV1AppAppIdAttemptEndpointEndpointIdGet(param, options) {
        return this.api.listAttemptsByEndpointApiV1AppAppIdAttemptEndpointEndpointIdGet(param.appId, param.endpointId, param.iterator, param.limit, param.status, param.statusCodeClass, param.eventTypes, param.channel, param.before, param.after, param.idempotencyKey, options).toPromise();
    }
    listAttemptsByMsgApiV1AppAppIdAttemptMsgMsgIdGet(param, options) {
        return this.api.listAttemptsByMsgApiV1AppAppIdAttemptMsgMsgIdGet(param.appId, param.msgId, param.endpointId, param.iterator, param.limit, param.status, param.statusCodeClass, param.eventTypes, param.channel, param.before, param.after, param.idempotencyKey, options).toPromise();
    }
    listAttemptsForEndpointApiV1AppAppIdMsgMsgIdEndpointEndpointIdAttemptGet(param, options) {
        return this.api.listAttemptsForEndpointApiV1AppAppIdMsgMsgIdEndpointEndpointIdAttemptGet(param.msgId, param.appId, param.endpointId, param.iterator, param.limit, param.eventTypes, param.channel, param.status, param.before, param.after, param.idempotencyKey, options).toPromise();
    }
    resendWebhookApiV1AppAppIdMsgMsgIdEndpointEndpointIdResendPost(param, options) {
        return this.api.resendWebhookApiV1AppAppIdMsgMsgIdEndpointEndpointIdResendPost(param.endpointId, param.msgId, param.appId, param.idempotencyKey, options).toPromise();
    }
}
exports.ObjectMessageAttemptApi = ObjectMessageAttemptApi;
const ObservableAPI_11 = require("./ObservableAPI");
class ObjectStatisticsApi {
    constructor(configuration, requestFactory, responseProcessor) {
        this.api = new ObservableAPI_11.ObservableStatisticsApi(configuration, requestFactory, responseProcessor);
    }
    getAppAttemptStatsApiV1StatsAppAppIdAttemptGet(param, options) {
        return this.api.getAppAttemptStatsApiV1StatsAppAppIdAttemptGet(param.appId, param.startDate, param.endDate, param.idempotencyKey, options).toPromise();
    }
    getEpStatsApiV1StatsAppAppIdEpEndpointIdAttemptGet(param, options) {
        return this.api.getEpStatsApiV1StatsAppAppIdEpEndpointIdAttemptGet(param.endpointId, param.appId, param.startDate, param.endDate, param.idempotencyKey, options).toPromise();
    }
}
exports.ObjectStatisticsApi = ObjectStatisticsApi;
//# sourceMappingURL=ObjectParamAPI.js.map